import type { SoundKind } from './audio';

/** One tap moves a nature sound to the next step: off → soft → medium → clear → off. */
export type SoundLevel = 0 | 1 | 2 | 3;
export const LEVEL_VOLUMES: readonly [number, number, number, number] = [0, 0.05, 0.12, 0.25];
export const DEFAULT_SOUND_VOLUMES: Record<SoundKind, number> = { rain: LEVEL_VOLUMES[2], stream: 0, wind: LEVEL_VOLUMES[1] };
export const SOUND_KINDS: readonly SoundKind[] = ['rain', 'stream', 'wind'];

/** Maps any slider volume (0–1) to the nearest tap step, so the bar and the sliders agree. */
export function levelOf(volume: number): SoundLevel {
  if (volume <= 0.001) return 0;
  if (volume < (LEVEL_VOLUMES[1] + LEVEL_VOLUMES[2]) / 2) return 1;
  if (volume < (LEVEL_VOLUMES[2] + LEVEL_VOLUMES[3]) / 2) return 2;
  return 3;
}

export function nextLevel(level: SoundLevel): SoundLevel {
  return ((level + 1) % LEVEL_VOLUMES.length) as SoundLevel;
}
